import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../styles/ModalComponent.css';
import { bool, func, node, string } from 'prop-types';

const ModalComponentNoButton = ({ modalTriggerText, modalTitle, children, handleSave = () => { }, show, setShow = () => {} }) => {
    const handleClose = () => setShow(false);
    const onHandleSave = () => {
        handleSave();
        setShow(false);
    };
    return (
        <Modal
            style={{ zIndex: '10000' }}
            show={show}
            onHide={handleClose}>
            <Modal.Header
                closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button
                    variant={'secondary'}
                    onClick={handleClose}>
                Close
                </Button>
                <Button
                    variant={'primary'}
                    onClick={onHandleSave}>
                Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalComponentNoButton.propTypes = {
    modalTriggerText: string,
    modalTitle: string,
    children: node,
    handleSave: func,
    show: bool,
    setShow: func,
};

export default ModalComponentNoButton;